import { EvtHeader } from "components/header";
import { useParams } from "react-router-dom";
import BillableExtensionForm from "../form";

const CreateBillableExtension = () => {
  const { billableId } = useParams();

  return (
    <div className="flex-1">
      <EvtHeader title="Create Extension" />
      <div className="p-6 max-w-md">
        <BillableExtensionForm billableId={billableId} />
      </div>
    </div>
  );
};

export default CreateBillableExtension;
